/* import __COLOCATED_TEMPLATE__ from './role-filter.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { difference, isEqual, without } from 'underscore';
import {
  NO_FILTER,
  WITHOUT_FILTER_VALUE,
  ROLE_FILTER_TYPE,
} from 'embercom/lib/settings/filters/constants';

export default class RoleFilter extends Component {
  @service intl;

  @tracked selectedFilter = this.args.filterValues;
  @tracked label = this.currentLabel;

  get filterItems() {
    let sortedRoles = this.args.roles.sortBy('name');
    return [
      {
        items: [
          {
            text: this.intl.t('settings.filters.role-filter.any'),
            value: NO_FILTER,
            isSelected: this.selectedFilter.includes(NO_FILTER),
          },
          {
            text: this.intl.t('settings.filters.role-filter.no-role'),
            value: WITHOUT_FILTER_VALUE,
            isSelected: this.selectedFilter.includes(WITHOUT_FILTER_VALUE),
          },
        ],
      },
      {
        heading: this.intl.t('settings.filters.role-filter.roles'),
        items: sortedRoles.map((role) => {
          return {
            text: role.name,
            value: role.id,
            isSelected: this.selectedFilter.includes(role.id),
          };
        }),
      },
    ];
  }

  get currentLabel() {
    if (isEqual(this.selectedFilter, [NO_FILTER])) {
      return this.intl.t('settings.filters.role-filter.any');
    } else if (isEqual(this.selectedFilter, [WITHOUT_FILTER_VALUE])) {
      return this.intl.t('settings.filters.role-filter.no-role');
    } else {
      let selectedRoleNames = this.selectedFilter.map((filterValue) => {
        return this.args.roles.find((role) => role.id === filterValue).name;
      });
      return selectedRoleNames.join(', ');
    }
  }

  @action
  onChangeFilterValue(value) {
    let addedFilterValue = difference(value, this.selectedFilter);

    if (isEqual(addedFilterValue, [NO_FILTER]) || isEqual(value, [])) {
      this.selectedFilter = [NO_FILTER];
    } else if (isEqual(addedFilterValue, [WITHOUT_FILTER_VALUE])) {
      this.selectedFilter = [WITHOUT_FILTER_VALUE];
    } else {
      this.selectedFilter = without(value, NO_FILTER, WITHOUT_FILTER_VALUE);
    }

    this.label = this.currentLabel;
  }

  @action
  clearFilters() {
    if (isEqual(this.args.filterValues, [NO_FILTER])) {
      this.selectedFilter = this.args.filterValues;
      this.label = this.currentLabel;
    }
  }

  @action
  updateFilter() {
    let selectedFilters = this.filterItems.flatMap((item) =>
      item.items.filter((item) => item.isSelected),
    );

    let filterValue = selectedFilters ? selectedFilters.map((item) => item.value) : [NO_FILTER];
    this.args.updateFilterValues(ROLE_FILTER_TYPE, filterValue);
  }
}
